<template>
    <b-button
        v-if="!sent"
        variant="outline-primary"
        @click="send"
        :id="'report-button-' + reportId"
    >
        <b-spinner
            class="status_spinner"
            v-if="sending"
            small
            label="Spinning"
        ></b-spinner>
        <template v-else>
            <font-awesome-icon :icon="['fas', 'paper-plane']" />
            Send
        </template>
    </b-button>
</template>

<style scoped>
.status_spinner {
  margin-left: 5px;
  margin-right: 5px;
}
</style>

<script>
import axios from "axios";

export default {
  name: "ReportSendButton",
  props: {
    reportId: { type: Number },
    clientName: { type: String, default: "" },
    reportName: { type: String, default: "" },
    isSent: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      sent: this.isSent,
      sending: false
    };
  },
  methods: {
    send() {
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure you want to send this report? It will be sent to all users for client '" +
            this.clientName +
            "' that have been subscribed to report notifications.",
          {
            title: "Send report " + this.reportName + " to the client",
            size: "md",
            buttonSize: "md",
            okVariant: "primary",
            okTitle: "Yes, send now",
            footerClass: "p-2",
            hideHeaderClose: false
          }
        )
        .then(value => {
          if (value) {
            this.sending = true;
            axios
              .post("/api/reports/" + this.reportId + "/send")
              .then(() => {
                this.sent = true;
                this.$emit("success", {
                  message: "The report has been sent."
                });
              })
              .catch(error => {
                let errorMessage = "Error while sending the report.";
                let customError = 0;
                if (
                  error.response.data.message ===
                  "Passport limit reached for this company."
                ) {
                  customError = 1;
                  errorMessage =
                    "You have reached the limit of passports you can generate. Please contact our services to unlock more passports !";
                }
                this.$emit("error", {
                  message: errorMessage,
                  errorCode: customError
                });
              })
              .finally(() => {
                this.sending = false;
              });
          }
        });
    }
  }
};
</script>
